import { round, range, transform } from "lodash/fp";
function generateSteps({ sliderWidth, min, max }) {
  if (!sliderWidth || sliderWidth < 0 || max < min) {
    return [];
  }
  if (max === min) {
    return [[max, 0, round(sliderWidth / 2)]];
  }
  const valRange = range(max, min - 1);
  const segmentSize = 1 / (max - min || 1);
  let proportion = 1;
  return transform(
    (steps, stepValue) => {
      const segmentLeft = sliderWidth * (proportion - segmentSize * 0.5);
      const segmentCenter = round(sliderWidth * proportion);
      steps.push([stepValue, segmentLeft, segmentCenter]);
      proportion -= segmentSize;
    },
    [],
    valRange
  );
}
export {
  generateSteps
};
